import { render, staticRenderFns } from "./Surface.vue?vue&type=template&id=54e12f88&"
import script from "./Surface.vue?vue&type=script&lang=js&"
export * from "./Surface.vue?vue&type=script&lang=js&"
import style0 from "./Surface.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports